import { Typography } from "@mui/material";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import * as React from "react";
import { useLanguage } from "../../Language";

export const GenreDisplay = ({ item }: { item: HostSystemItemView }) => {
  const { translate } = useLanguage();
  const { collection } = item;

  if (collection?.length > 0) {
    return (
      <Typography component={"h4"} variant={"subtitle2"}>
        {translate("genre")}: {collection}
      </Typography>
    );
  }

  return null;
};
